<template>
    <v-footer class="site-footer bg-transparent flex-column pa-0 flex-grow-0">
        <div class="site-footer__content d-block text-center text-secondary-dark">
            {{ t('profile.footerPrivacyPolicyText') }}
            <a class="text-primary" :href="config.privacyPolicyUrl">{{ t('profile.footerPrivacyPolicyLinkText') }}</a>
        </div>
        <v-sheet height="48" class="bg-header w-100" />
    </v-footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useAppConfiguration } from '@/composables';

const { t } = useI18n();
const { config } = useAppConfiguration();
</script>

<style lang="scss">
@use 'sass:map';
@use 'vuetify/settings' as *;

.site-footer {
    &__content {
        width: 100%;
        padding: ($spacer * 6) ($spacer * 4) ($spacer * 16);

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            padding-top: $spacer * 10;
            padding-bottom: $spacer * 21;
        }
    }
}
</style>
